module.exports = __webpack_public_path__ + "static/media/finance.8f3ea22d.png";